export default "__VITE_ASSET__Cd8_K36O__"